import { render } from "./ArticleRelated.vue?vue&type=template&id=606c2af1&scoped=true"
import script from "./ArticleRelated.vue?vue&type=script&lang=js"
export * from "./ArticleRelated.vue?vue&type=script&lang=js"

import "./ArticleRelated.vue?vue&type=style&index=0&id=606c2af1&scoped=true&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606c2af1"]])

export default __exports__